<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const route = useRoute();
const router = useRouter();
const { accountScopedRoute } = useAccount();

const isFlowsTab = computed(() => {
  return (
    (route.name === 'telephony_ivr' ||
      route.name === 'whatsapp_calling_ivr') &&
    route.query.tab === 'flows'
  );
});

const isWhatsApp = computed(() => route.name === 'whatsapp_calling_ivr');

const currentAccountId = useMapGetter('getCurrentAccountId');
const isFeatureEnabledonAccount = useMapGetter(
  'accounts/isFeatureEnabledonAccount'
);

const showFlowBuilderLauncher = computed(() => {
  const isTelephonyEnabled =
    isFeatureEnabledonAccount.value(
      currentAccountId.value,
      FEATURE_FLAGS.ASTERISK_TELEPHONY
    ) ||
    isFeatureEnabledonAccount.value(
      currentAccountId.value,
      FEATURE_FLAGS.WHATSAPP_SIP_TELEPHONY
    );
  return isTelephonyEnabled && isFlowsTab.value;
});

const goToBuilder = () => {
  const routeName = isWhatsApp.value
    ? 'whatsapp_calling_ivr_builder_new'
    : 'telephony_ivr_builder_new';
  router.push(accountScopedRoute(routeName));
};
</script>

<template>
  <div
    v-if="showFlowBuilderLauncher"
    class="fixed bottom-4 ltr:right-4 rtl:left-4 z-50"
  >
    <div class="rounded-full bg-n-alpha-2 p-1">
      <Button
        v-tooltip.left="'Novo Fluxo IVR'"
        icon="i-lucide-git-branch-plus"
        class="!rounded-full !bg-n-solid-3 dark:!bg-n-alpha-2 !text-n-slate-12 text-xl"
        lg
        @click="goToBuilder"
      />
    </div>
  </div>
  <template v-else />
</template>
